import React from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import MainForm from "./form"
import LandingHeader from "./landingheader"

const Landing = () => {
  return (
    <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
      <LandingHeader />
      <Grid type="main" className="landing-page-main">
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <MainForm />
          </Col>
        </Row>
      </Grid>
    </Block>
  )
}

export default Landing
